uniform float uAlpha;
varying vec4 vPosition;
uniform float uRadius;
uniform vec3 uColor;

void main() {
  float transitionWidth = 0.1;
  float normalizedY = (vPosition.y + uRadius) / (2.0 * uRadius);
  float fadeMask = 1.0 - smoothstep(uAlpha - transitionWidth, uAlpha, normalizedY);
  gl_FragColor = vec4(uColor, fadeMask); 
  }